import { ComponentType, SVGProps } from 'react';

import { StyledIconButton, TransportIconWrapper } from '../styles';

interface TransportIconProps {
	icon: ComponentType<SVGProps<SVGSVGElement>>;
	onClick: () => void;
	isPrimary?: boolean;
	'aria-label': string;
}

export default function TransportIcon({
	icon: Icon,
	onClick,
	isPrimary = false,
	'aria-label': ariaLabel,
}: TransportIconProps) {
	return (
		<TransportIconWrapper $isPrimary={isPrimary}>
			<StyledIconButton onClick={onClick} $isPrimary={isPrimary} aria-label={ariaLabel}>
				<Icon />
			</StyledIconButton>
		</TransportIconWrapper>
	);
}
